var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.compact ? 'gap-3' : 'gap-x-10 gap-y-8',
    _vm.direction === 'inline'
      ? 'grid grid-cols-[repeat(auto-fit,_minmax(12em,_1fr))]'
      : 'flex flex-col'
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }